import { HttpStatusCode, isAxiosError } from "axios";
import { SendToTrackingService } from "@/api/handlers/errors";
import {
  type CreatePlotRequestDetailRequest,
  type SavedMapPlotRequestDetail,
} from "@/features/map/types";
import { useApiClient } from "@/hooks/useApiClient";
import useSWRMutation, { type SWRMutationResponse } from "swr/mutation";

/**
 * プロット詳細を追加するカスタムフック
 */
export const useCreatePlotRequestDetail = (): SWRMutationResponse<
  SavedMapPlotRequestDetail,
  Error,
  string,
  CreatePlotRequestDetailRequest
> => {
  const { apiClient } = useApiClient();
  const url = "/map/plot-request-details";

  const fetcher = async (
    url: string,
    { arg }: { arg: CreatePlotRequestDetailRequest }
  ): Promise<SavedMapPlotRequestDetail> => {
    try {
      const response = await apiClient.post<SavedMapPlotRequestDetail>(
        url,
        arg
      );

      if (
        response.status !== HttpStatusCode.Created &&
        response.status !== HttpStatusCode.Ok
      ) {
        throw new Error("プロット詳細の追加に失敗しました");
      }

      return response.data;
    } catch (error) {
      if (
        isAxiosError(error) &&
        (error.response?.status ?? HttpStatusCode.InternalServerError) >=
          HttpStatusCode.InternalServerError
      ) {
        SendToTrackingService(error);
      }
      throw error;
    }
  };

  return useSWRMutation(url, fetcher, { revalidate: false });
};
